__turbopack_context__.v({
  "box": "ContactEmailBox-module-scss-module__xhDwIa__box",
  "description": "ContactEmailBox-module-scss-module__xhDwIa__description",
  "fade-in": "ContactEmailBox-module-scss-module__xhDwIa__fade-in",
  "heading": "ContactEmailBox-module-scss-module__xhDwIa__heading",
  "no-transform": "ContactEmailBox-module-scss-module__xhDwIa__no-transform",
  "rotate": "ContactEmailBox-module-scss-module__xhDwIa__rotate",
});
